import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from "./../../components/UI-Components";
import StarBorder from '@material-ui/icons/StarBorder'
import StarHalf from '@material-ui/icons/StarHalf'
import Star from '@material-ui/icons/Star'



const StarIcon = props => {
    return(
        <>
          {
              props.fill ?
               <Star style={{color: 'gold'}}/>
               :
               props.half
               ?
               <StarHalf style={{color: 'gold'}}/>
               :
               <StarBorder/>
          }
        </>
    )
}

export default props => {
    const ratingPoint = Math.floor(props.ratings)
    const remainingPoint = (props.ratings- ratingPoint).toFixed(1);
    const half = JSON.parse(remainingPoint) >= 0.5 ? true : false;
    let emptyStarts = 5 - ratingPoint;
        emptyStarts = half ? emptyStarts - 1 : emptyStarts;


    return(
        <View style={styles.ratingWrapper}>
            <View style={styles.startsWrapper}>
             {
                 Array(ratingPoint).fill('').map((x, index) => {
                     return <StarIcon fill key={index}/>
                 })
             }
             { 
                half &&  
                     <StarIcon half />
             }
             { 
                  Array(emptyStarts).fill('').map((x, index) => {
                    return <StarIcon key={index}/>
                })
             }
              
              
            </View>
            <View style={{flexDirection: 'row', flex: 1, justifyContent: 'flex-end', alignItems: 'flex-end'}}>
                <Text style={styles.ratingNumber}>{props.ratings}</Text>
                
            </View>
        </View>
    )

}

const styles = StyleSheet.create({
    ratingWrapper: {
        flexDirection: 'row',      
    },
    startsWrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'       
    },
    ratingNumber: {
        fontSize: 16, 
        fontWeight: '600',
        marginRight: 2
    },
    noOfRatedUsers: {
        fontSize: 10,
        color: 'rgba(0,0,0,0.6)',
        marginBottom: 3
    },
})
